import bookingsAPI from "../../API/endpoints/bookings";
import { sliceActions } from "../bookings-slice";

export const fetch = (query) => {
  return async (dispatch) => {
    dispatch(sliceActions.setLoading(true));
    try {
      const response = await bookingsAPI.get({ ...query, active: true });
      dispatch(sliceActions.populateData(response.data.content));
      dispatch(
        sliceActions.setMeta({
          total: response.data.totalElements,
          currentPage: response.data.number,
          pageSize: response.data.size,
        })
      );
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(sliceActions.setLoading(false));
    }
  };
};

export const create = (payload) => {
  return async (dispatch) => {
    try {
      await bookingsAPI.create(payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const update = (id, payload) => {
  return async (dispatch) => {
    try {
      dispatch(sliceActions.setLoading(true));
      await bookingsAPI.update(id, payload);
      dispatch(fetch());
    } catch (error) {
      throw error;
    } finally {
      dispatch(sliceActions.setLoading(false));
    }
  };
};

export const cancel = (id) => {
  return async (dispatch) => {
    try {
      dispatch(sliceActions.setLoading(true));
      await bookingsAPI.cancel(id);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(sliceActions.setLoading(false));
    }
  };
};
